import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";

const ContactPage = lazy(() => import('./pages/contact'));
const Experience = lazy(() => import('./pages/experience'));
const Skills = lazy(() => import('./pages/skills'));
const Projects = lazy(() => import('./pages/projects'));
const About = lazy(() => import('./pages/about'));
const Homepage = lazy(() => import('./pages/homepage'));
const Certificates = lazy(() => import('./pages/certificates'));

const Routes = ({ RouterComponent = BrowserRouter, routerProps, staticHomepage }) => {
  return (
    <RouterComponent {...routerProps}>
      <ErrorBoundary>
      <ScrollToTop />
      <Suspense fallback={null}>
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={staticHomepage ? React.createElement(staticHomepage) : <Homepage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/about" element={<About />} />
        <Route path="/homepage" element={<Navigate to="/" replace />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </Suspense>
      </ErrorBoundary>
    </RouterComponent>
  );
};

export default Routes;
